// Placeholder card surfaced on tabs 4-8 of the Deal detail page
// (Underwriting, the analyst tabs and Closing) while the deal is earlier
// than the tab's gating stage. Callers supply the title and body copy.

import { Card } from "@/design-system/components/ui";
import { Clock } from "lucide-react";

interface TabPlaceholderCardProps {
  title: string;
  body: string;
}

export function TabPlaceholderCard({ title, body }: TabPlaceholderCardProps) {
  return (
    <Card>
      <div className="flex flex-col items-center text-center py-space-6 px-space-4 gap-space-3">
        <Clock size={32} className="text-gold-shadow" aria-hidden />
        <h3 className="font-display text-h3 text-onyx m-0">{title}</h3>
        <p className="text-small text-gray-mid max-w-md whitespace-pre-line m-0">
          {body}
        </p>
      </div>
    </Card>
  );
}
